export const SET_TURN_ON_ACTIVE = 'setTurnOnActive'
export const SET_TURN_OFF_ACTIVE = 'setTurnOffActive'
